module.exports = __webpack_public_path__ + "static/img/call-pass.114be2f5.png";